import { render, staticRenderFns } from "./PreviewJobCompanyDetail.vue?vue&type=template&id=6742378c&scoped=true"
import script from "./PreviewJobCompanyDetail.vue?vue&type=script&lang=js"
export * from "./PreviewJobCompanyDetail.vue?vue&type=script&lang=js"
import style0 from "./PreviewJobCompanyDetail.vue?vue&type=style&index=0&id=6742378c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6742378c",
  null
  
)

export default component.exports